/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-05-17 10:07:44
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';

import PlanWrapper from './plan-wrapper';
import PlanPackage from 'src/components/views/subscription-v3/plan-package';
import FeedbackModal from 'src/components/views/subscription-v3/addon/unsubscribe-feedback-modal';
import { routes } from 'src/routes';
import { buildAddonAdded } from 'src/helpers/subscription-v3-helper.js';

import PlanSummary from 'src/components/views/subscription-v3/plan-summary';

import type { WithI18nProps } from '@shopify/react-i18n';
import type { WrapperComponentPropsType } from './plan.type';
type ComposedProps = WrapperComponentPropsType & WithI18nProps;
class Plan extends Component<ComposedProps> {
  state = {
    openFeedback: false,
    title: '',
    isTrialPeriod: false
  };

  render() {
    const {
      selectedPlan = '',
      currentTotalProducts,
      subscription,
      gettingInvoice,
      invoice,
      unsubscribing,
      gettingPackage,
      planInfo = {},
      packageInfo = {},
      packagePlans,
      allAddon
    } = this.props;
    const { openFeedback, title, isTrialPeriod } = this.state;
    const nextBillingDate = _.get(invoice, 'nextBillingDate', '');

    const { status = '', regularExpiredAt = 0 } = subscription;

    const isTrialUser = ['trial', 'expiredSoon', 'expired'].includes(status);
    const addonsAdded = buildAddonAdded(allAddon, status);
    return (
      <div className="subscription-plan">
        <PlanSummary
          status={status}
          regularExpiredAt={regularExpiredAt}
          packageInfo={packageInfo}
          planInfo={planInfo}
          selectedPlan={selectedPlan}
          addonsAdded={addonsAdded}
          unsubscribing={unsubscribing}
          nextBillingDate={nextBillingDate}
          handleUnsubscribe={this.handleUnsubscribeAddon}
          onOpenFeedback={this.handleOpenFeedback}
          getUnsubscribeAddOnInfo={this.getUnsubscribeAddOnInfo}
        />
        {/* Render current package view of tenantApp */}
        {isTrialUser && (
          <PlanPackage
            gettingInvoice={gettingInvoice}
            gettingPackage={gettingPackage}
            invoice={invoice}
            currentTotalProducts={currentTotalProducts}
            packagePlans={packagePlans}
          />
        )}
        <FeedbackModal
          handleFeedbackModal={this.handleCloseChangeStateFeedback}
          openFeedback={openFeedback}
          addonName={title}
          isTrialPeriod={isTrialPeriod}
        />
      </div>
    );
  }
  // Open addon page
  handleViewAddon = () => {
    const { history } = this.props;
    history.push(routes.subscription.addon());
  };

  // action unsubscribe addon
  handleUnsubscribeAddon = async (id, addOnName, isTrialPeriod = false) => {
    const { unsubscribeAddon, code, clearDiscountCode, subscription } = this.props;
    const { status = '' } = subscription;
    this.setState({
      isTrialPeriod
    });
    await unsubscribeAddon(id, addOnName);
    if (['trial', 'expiredSoon', 'expired'].includes(status) && !_.isEmpty(code)) {
      await clearDiscountCode();
    }
  };

  // action open feedback
  handleOpenFeedback = title => {
    this.setState({
      title: title,
      openFeedback: true
    });
  };

  // Close feedback modal
  handleCloseChangeStateFeedback = () => {
    this.setState({
      openFeedback: false,
      title: '',
      isTrialPeriod: false
    });
  };

  // get unsubscribe addon info
  getUnsubscribeAddOnInfo = addon => {
    const { subscribedAddOnsInfos = [] } = this.props;
    if (addon) {
      const result = subscribedAddOnsInfos.find(item => item.id === addon?.id);
      return result;
    }
    return null;
  };
}

export default PlanWrapper(Plan);
